import { BULK_CREATE_PARENT_GOLD_PRICES_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function BulkPostParentGoldPrice(data){
  const api = `${BULK_CREATE_PARENT_GOLD_PRICES_API}`;
  return axiosHttp.post(api, data);
}
